import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStoreGeneral } from '@types';

const initialState: IStoreGeneral = {
  maleNumber: 0,
  femaleNumber: 0,
  wholeGenderNumber: 0,
  isWholeGenderNumberChecked: false
};

export const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    initGeneral: () => {
      return initialState;
    },

    setGeneral: (state, action: PayloadAction<Partial<IStoreGeneral>>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { initGeneral, setGeneral } = generalSlice.actions;

export default generalSlice.reducer;
